<template>
    <div>
		<div @dragover.prevent @drop="uploadFile" :class="[
			'dropFile',
			dropError ? 'dropError' : '',
		]">
			<div v-if="!getIsUploading" class="dropFile__drop-message">
				Drop a audio file here to upload
				<span class="dropFile__drop-error-message" v-if="dropError"><br/>{{dropError}}</span>
			</div>
			<div v-if="getIsUploading" class="dropFile__drop-message">Audio is uploading</div>
		</div>
		<progress-bar :val="uploadProgress"></progress-bar>
    </div>
</template>

<script>

	import { UPLOAD_S3_MEDIA } from '@/store/actions/upload'
	import ProgressBar from 'vue-simple-progress'

	import routes from '@/router'
	
	import { mapGetters } from 'vuex'

	export default {

		name: 'AudioUploader',

		components: {
			ProgressBar
		},

		computed:{
			...mapGetters(['getUploadsInProgress', 'getIsUploading']),
			hasUploadedFile(){
				return ( this._uid in this.getUploadsInProgress )
			},
			uploadProgress(){
				if(this._uid in this.getUploadsInProgress){
					return this.getUploadsInProgress[this._uid].progress
				}else{
					return 0
				}
			}

		},

		data() {
			return {
				dropError: null,
			}
		},

		methods:{
			uploadFile(e){
				e.stopPropagation();
				e.preventDefault();
				var dt    = e.dataTransfer;
				var files = dt.files;
				var file = files[0];
				var fileName = file.name.replace(/ /g,'')
				if((file.type.match("audio") && file.type.match("mpeg")) || (file.type.match("audio") && file.type.match("x-m4a"))){
					this.$emit('file-added', fileName)
					this.$store.dispatch(UPLOAD_S3_MEDIA, {
						name: fileName,
						type: file.type,
						forRepository:routes.app.$route.params.repoName,
						forComponent:this.$parent.$vnode.componentOptions.tag,
						file: file,
						fromComponent: this
					})
					this.dropError = null;
				}else{
					this.dropError = "File format not supported,  needs to be a mp3 or m4a";
				}
			}
		}

    }
</script>

<style lang="scss" scoped>

	@import '@/scss/style.scss';
	
	.dropFile{
					position: relative;
		border: 2px solid #e5e5e5;
		display:block;
		width: 100%;
		height: 100px;
		&__drop-message{
			position: relative;
			color: #777;
			text-align: center;
			top: 50%;
			transform: translateY(-50%);
		}
		&__drop-error-message{
			color:#FF0000;
		}
	}

	.dropError{
		background-color: rgba($color: #FF0000, $alpha: 0.1);
	}

	.backgroundImage{
		padding: 20px 0;
	}
	h5{
		padding-bottom: 10px;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>